import styled from 'styled-components'

export const modalVisualizarAssociacaoStyles = {
  Container: styled.div``
}
